import SearchIcon from 'icons/Search'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

function EmptySearchField() {
  const { t: translate } = useTranslation()

  return (
    <div className="search-list_empty-search-field">
      <SearchIcon className="icon search-big-icon" />

      <div className="search-list_empty-search-field-text">{translate('search.emptySearchField')}</div>
    </div>
  )
}

export default memo(EmptySearchField)
